import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import {SweetSweet_1Screen} from "../SweetSweet/game_1Screen";

export class SweetSweetLink_1Screen extends SweetSweet_1Screen {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "SweetSweetLink");
    }

}
